import { Tooltip, Col, Row } from 'antd';
import React, { createRef, useState } from 'react';
import QRCode from 'react-qr-code';
import { useScreenshot, createFileName } from 'use-react-screenshot';

import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import { translate } from '@portal/services/i18n';
import { EventType } from '@portal/enum/analytics';
import { sendEvent } from '@portal/services/firebase';
import ThemedText from '@portal/components/ThemedText/ThemedText';

interface IProps {
  content: string;
  hideHeader?: boolean;
  center?: boolean;
  description?: boolean;
  buttons?: boolean;
}

const QRCodeDetails = (props: IProps) => {
  const ref = createRef<HTMLDivElement>();
  const [, takeScreenShot] = useScreenshot({
    type: 'image/jpeg',
    quality: 1.0,
  });
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const handleCopyCode = () => {
    setIsTooltipVisible(true);
    navigator.clipboard.writeText(props.content);
    setTimeout(() => {
      setIsTooltipVisible(false);
    }, 2000);

    sendEvent(EventType.SHARE_PIX_QR_CODE);
  };

  const download = (image: string) => {
    const a = document.createElement('a');
    a.href = image;
    a.download = createFileName(
      'jpg',
      translate('PAGES.HOME.RECEIVE.QR_CODE.IMAGE_NAME')
    );
    a.click();
  };

  const downloadScreenshot = () => takeScreenShot(ref.current).then(download);

  return (
    <div>
      {!props.hideHeader && (
        <p className="qr-code-details__info">
          {translate('PAGES.HOME.RECEIVE.QR_CODE.TITLE')}
        </p>
      )}
      <Row
        align={props.center ? 'middle' : undefined}
        justify={props.center ? 'center' : undefined}
        ref={ref}
      >
        <QRCode value={props.content} />
      </Row>
      {props.description ?? (
        <ThemedText variant="body" className="qr-code-details__description">
          {props.content}
        </ThemedText>
      )}
      {props.buttons ? (
        <div className="receive__buttons">
          <Col className="qr-code-details__button">
            <Tooltip
              title={translate('PAGES.HOME.RECEIVE.QR_CODE.COPIED')}
              open={isTooltipVisible}
              placement="rightTop"
              mouseLeaveDelay={0.5}
              mouseEnterDelay={0.2}
            >
              <AdvancedButton
                text={translate('PAGES.HOME.RECEIVE.QR_CODE.COPY')}
                size="large"
                onClick={handleCopyCode}
              />
            </Tooltip>
            <AdvancedButton
              text={translate('PAGES.HOME.RECEIVE.QR_CODE.SAVE')}
              size="large"
              onClick={downloadScreenshot}
            />
          </Col>
        </div>
      ) : null}
    </div>
  );
};

export default QRCodeDetails;
